import $ from 'jquery';

$('.faq-collapse__disabled-link').click(function () {
    $(this).parent().click();
});

